jQuery(document).ready(function(){
    //sticky-header
    jQuery(window).scroll(function(){
        var sticky = jQuery('.site-header'),
            scroll = jQuery(window).scrollTop();
    
        if (scroll >= 10) sticky.addClass('nav-fixed');
        else sticky.removeClass('nav-fixed');
    });


    jQuery("#versatility_slider, #products_slider").slick({
        autoplay:true,
        autoplaySpeed:2000,
        speed:500,
        slidesToShow:3,
        slidesToScroll:1,
        dots:false,
        arrows:false,
        infinite:true,
        centerMode: false,
        variableWidth: false,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 441,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
    });
    jQuery("#marketing_video_slider").slick({
        autoplay:true,
        autoplaySpeed:2000,
        speed:500,
        slidesToShow:7,
        slidesToScroll:1,
        dots:false,
        arrows:false,
        infinite:true,
        centerMode: true,
        variableWidth: false,
        responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 6,
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
              }
            },
            {
                breakpoint: 992,
                settings: {
                  slidesToShow: 4,
                }
              },
            {
                breakpoint: 481,
                settings: {
                  slidesToShow: 3,
                }
              }
          ]
    });

  
    jQuery("#_posts_slider").slick({
        autoplay:true,
        autoplaySpeed:2000,
        speed:500,
        slidesToShow:3,
        slidesToScroll:1,
        dots:false,
        arrows:false,
        infinite:true,
        centerMode: true,
        variableWidth: false,
        responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              }
            },
            {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                }
              },
            {
                breakpoint: 481,
                settings: {
                  slidesToShow: 1,
                }
              }
          ]
    });


    jQuery('#_posts_slider, #versatility_slider, #products_slider, #marketing_video_slider').on('afterChange', function(event, slick, currentSlide){
      jQuery(slick.$slides).removeAttr('aria-hidden');
    });
    

  
    
    jQuery("#menu_toggle").on('click' , function(){
        jQuery(this).toggleClass('active');
        jQuery(".mainMenu_wrap").addClass('show');
    });
    jQuery("#menu_close").on('click' , function(){
        jQuery(this).toggleClass('active');
        jQuery(".mainMenu_wrap").removeClass('show');
    });
});